import { lazy } from 'react';

const UnapprovedUser = lazy(() => import('./UnaprovedUser'));

export default {
    UnapprovedUser
}
